<script setup>
import { computed, inject } from "vue";
import { useStore } from "@/Stores/domain";
import { ExclamationTriangleIcon } from "@heroicons/vue/20/solid";
import { useI18n } from "vue-i18n";

const store = useStore();
const { t: __ } = useI18n();
const $showPricingPlans = inject("$showPricingPlans");

const isPremium = computed(() => {
    return store.domain?.is_premium;
});

const isTrialActive = computed(() => {
    return !isPremium.value && store.user?.trial.status === "active" && remainingUsage.value > 0;
});

const isTrialEnded = computed(() => {
    return !isPremium.value && (store.user?.trial.status === "ended" || remainingUsage.value <= 0);
});

const remainingUsage = computed(() => {
    let usage = store.user?.trial.usage ?? 0;
    let maxUsage = store.user?.trial.max_usage ?? 0;

    return Math.max(0, maxUsage - usage);
});
</script>

<template>
    <div v-if="isTrialActive || isTrialEnded" class="p-4 border-yellow-400 sm:px-6 lg:px-8 bg-yellow-50">
        <div class="flex">
            <div class="flex-shrink-0">
                <ExclamationTriangleIcon class="w-5 h-5 text-yellow-400" aria-hidden="true" />
            </div>
            <div class="ml-3">
                <template v-if="isTrialActive">
                    <div class="text-sm text-yellow-700">
                        {{
                            __("Il vous reste {remainingUsage} générations disponibles sur votre version d'essai.", {
                                remainingUsage: remainingUsage,
                            })
                        }}
                        {{ " " }}
                        <div class="inline font-medium text-yellow-700 underline cursor-pointer hover:text-yellow-600" @click.prevent="$showPricingPlans()">
                            {{ __("Mettez à niveau votre compte.") }}
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="text-sm text-yellow-700">
                        {{ __("Vous n'avez plus de générations disponibles sur votre version d'essai.") }}
                        {{ " " }}
                        <div class="inline font-medium text-yellow-700 underline cursor-pointer hover:text-yellow-600" @click.prevent="$showPricingPlans()">
                            {{ __("Mettez à niveau votre compte.") }}
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
